import { lazyImport } from '../../../Utils/Loading/loadingHelpers'

const Checkbox = lazyImport<typeof import('@mui/material/Checkbox').default>(
  () => import(/* webpackChunkName: "mui-checkbox" */ '@mui/material/Checkbox')
)

export { Checkbox }
